class ExternalAgencyIdProperties {
	public label: string | null = null;
	public required: boolean | null = null;;
} 

export default ExternalAgencyIdProperties;